import { z } from "zod";

import { auditDate } from "@/schemas";

import { environmentalChecklistItemWithTicket } from "../../../../schemas";

export const moveInMoveOutBedroomSchema = z.object({
  locationId: z.string().min(1, "Required"),
  auditDate: auditDate,
  reviewerId: z.string().min(1, "Required"),
  bedroomDescription: z.string().min(1, "Required"),
  bedroomDoor: environmentalChecklistItemWithTicket,
  bedroomWall: environmentalChecklistItemWithTicket,
  bedroomFixture: environmentalChecklistItemWithTicket,
  bedroomWindow: environmentalChecklistItemWithTicket,
  bedroomFloor: environmentalChecklistItemWithTicket,
  bedroomCeiling: environmentalChecklistItemWithTicket,
});
